export enum MonitorValueType {
  VEM = 'VEM',
  DSGram = 'DSGram',
  Protein = 'Protein',
  Sugar = 'Sugar',
  DSPercent = 'DSPercent',
  Height = 'Height',
}

export const MonitorValueTypeTranslations: {
  [T in MonitorValueType]: string;
} = {
  VEM: 'VEM',
  DSGram: 'Grasgroei',
  Protein: 'Eiwit',
  Sugar: 'Suiker',
  DSPercent: 'DS',
  Height: 'Groei',
};

export interface MonitorTargetValue {
  min: number | undefined;
  max: number | undefined;
}

export type MonitorTargetValues = {
  [T in MonitorValueType]: MonitorTargetValue;
};
